/** Default landing route after builder/incharge login */
export const getBuilderHomePath = (user) =>
  user?.role === "incharge" ? "/builder/projects" : "/builder/dashboard";
